const LogicBuilderConfig = {
	collection: "logic_builder",
	fields: ["id", "name", "logic", "locale.label", "locale.language"],

	adapter: class LogicBuilder {
		constructor(lb) {
			const { locale = [], ...other_props } = lb;

			Object.assign(this, other_props);
			this.label = (selected_locale) =>
				locale.find((l) => l.language === selected_locale)?.label || "";
		}
	}
};

export default LogicBuilderConfig;
